import { Icon } from '~/components/ui/icon';

export function GooseEgg() {
  return (
    <div className='mt-10 text-center md:mt-14'>
      <div className='bg-yellow mx-auto mb-4 mt-0 flex h-[72px] w-[72px] items-center justify-center rounded-full md:h-[104px] md:w-[104px]'>
        <Icon
          className='h-auto max-h-10 w-10 fill-white md:max-h-14 md:w-12'
          height={24}
          use='shining-star'
          width={24}
        />
      </div>
      <h2 className='m-0 text-xl md:text-2xl'>
        No hospitals were found, but we&apos;re adding new partners all the time!
      </h2>
      <p className='text-muted-foreground mx-0 mb-0 mt-2 text-base md:mt-4 md:text-lg'>
        Consider sponsoring the hospital with the greatest need.
      </p>
    </div>
  );
}
